// Prevents constant folding during production build optimization
// The try-catch block makes this function non-inlinable by terser
// Accepts 'true' and '1', the two spellings the deployment configs use
export function toBool(value: string): boolean {
  try {
    return value === 'true' || value === '1';
  } catch {
    return false;
  }
}

export const environment = {
  BASE_URL: 'BASE_URL_PLACEHOLDER',
  BASE_API_URL: 'BASE_API_URL_PLACEHOLDER',
  DATE_FORMAT: 'dd/MM/YYYY',
  DATETIME_FORMAT: 'dd/MM/YYYY HH:mm',
  PRODUCTION: true,
  RESTHEART_URL: 'RESTHEART_URL_PLACEHOLDER',
  // eslint-disable-next-line no-constant-condition
  BPA_SETTINGS_CACHE_DURATION_MS: 'BPA_SETTINGS_CACHE_DURATION_MS_PLACEHOLDER'
    ? Number('BPA_SETTINGS_CACHE_DURATION_MS_PLACEHOLDER') || 60 * 1000
    : 60 * 1000, // 1 minute
  DEFAULT_LANGUAGE: 'DEFAULT_LANGUAGE_PLACEHOLDER',
  TRANSLATE: {
    defaultLanguage: 'en'
  },
  KEYCLOAK_ACTIVE: toBool('KEYCLOAK_ACTIVE_PLACEHOLDER'),
  KEYCLOAK_URL: 'KEYCLOAK_URL_PLACEHOLDER',
  KEYCLOAK_REALM: 'KEYCLOAK_REALM_PLACEHOLDER',
  KEYCLOAK_INSTITUTIONS_GROUP_ID: 'KEYCLOAK_INSTITUTIONS_GROUP_ID_PLACEHOLDER',
  OAUTH_REDIRECT_URL: 'OAUTH_REDIRECT_URL_PLACEHOLDER',
  OAUTH_CLIENT_ID: 'OAUTH_CLIENT_ID_PLACEHOLDER',
  OAUTH_SECRET: 'OAUTH_SECRET_PLACEHOLDER',
  CAS_URL: 'CAS_URL_PLACEHOLDER',
  PARTC_URL: 'PARTC_URL_PLACEHOLDER',
  LOCAL: false,
  SYSTEM_CODE: 'SYSTEM_CODE_PLACEHOLDER',
  USE_BUSINESS_ENTITIES: toBool('USE_BUSINESS_ENTITIES_PLACEHOLDER'),
  USE_OLD_FE: toBool('USE_OLD_FE_PLACEHOLDER'),
  WS_URL: 'WS_URL_PLACEHOLDER',
  IVERI_MERCHANT_APPLICATION_ID: '{E4794759-C549-44E5-8869-6F2E363D70A8}',
  PAGE_INACTIVITY_JWT_CHECK_MILLIS: Number(
    'PAGE_INACTIVITY_JWT_CHECK_MILLIS_PLACEHOLDER'
  ),
  CUBAN_PRODUCT_LIST_URL: 'CUBAN_PRODUCT_LIST_URL_PLACEHOLDER',
  CUBAN_PRODUCT_LIST_DEBUG_LOGGING: toBool(
    'CUBAN_PRODUCT_LIST_DEBUG_LOGGING_PLACEHOLDER'
  ),
  WEBSOCKET_INTEGRATION_ACTIVE: toBool(
    'WEBSOCKET_INTEGRATION_ACTIVE_PLACEHOLDER'
  ),
  CONFIGURATOR_ENABLED: toBool('CONFIGURATOR_ENABLED_PLACEHOLDER'),
  DEBUG_MODE: toBool('DEBUG_MODE_PLACEHOLDER'),
  LEAPA_ENABLED: toBool('LEAPA_ENABLED_PLACEHOLDER'),
  LEAPA_API_KEY: 'LEAPA_API_KEY_PLACEHOLDER',
  REMITA_ENABLED: toBool('REMITA_ENABLED_PLACEHOLDER'),
  REMITA_SCRIPT_URL: 'REMITA_SCRIPT_URL_PLACEHOLDER',
  GA_MEASUREMENT_ID: 'GA_MEASUREMENT_ID_PLACEHOLDER',
  LOGOUT_REDIRECT_URL: 'LOGOUT_REDIRECT_URL_PLACEHOLDER',
  ENABLE_TOKEN_INTROSPECT: toBool('ENABLE_TOKEN_INTROSPECT_PLACEHOLDER'),
  BPA_URL: 'BPA_URL_PLACEHOLDER',
  STATS_URL: 'STATS_URL_PLACEHOLDER',
  IS_IFRAME_APP: toBool('IS_IFRAME_APP_PLACEHOLDER'),
  ALLOWED_ORIGINS: 'ALLOWED_ORIGINS_PLACEHOLDER'.split(',').filter(Boolean),
  USE_NEW_PART_B_LINK: toBool('USE_NEW_PART_B_LINK_PLACEHOLDER'),
  TRANSLATIONS_PATH: 'TRANSLATIONS_PATH_PLACEHOLDER',
  SHOW_SITE_NAME: toBool('SHOW_SITE_NAME_PLACEHOLDER')
};
